import { FieldError, UseFormRegisterReturn } from 'react-hook-form'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type InputProps = JSX.IntrinsicElements['input']

type FormInputProps = InputProps & {
  register: UseFormRegisterReturn
  errorMessage?: FieldError
  defaultValue?: string
  annotation?: string
  as?: keyof JSX.IntrinsicElements
}

export const FormInput = ({
  register,
  errorMessage,
  defaultValue,
  annotation,
  as,
  ...formInputProps
}: FormInputProps) => {
  return (
    <div>
      <Input
        {...formInputProps}
        {...register}
        defaultValue={defaultValue}
        as={as}
      />
      {errorMessage && (
        <FormErrorMessage>{errorMessage.message}</FormErrorMessage>
      )}
      {annotation && <Annotation>{annotation}</Annotation>}
    </div>
  )
}

const Input = styled.input<Pick<FormInputProps, 'as'>>`
  height: ${({ as }) => (as === 'textarea' ? '304px' : '56px')};
  border: 1px solid #707070;
  padding: 17px 20px 19px;
  width: 100%;
  font-size: 16px;
  letter-spacing: 0.28px;
  resize: vertical;

  &::placeholder {
    color: ${theme.colors.grey};
  }

  @media screen and (max-width: 1047px) {
    max-width: none;
  }
`

const Annotation = styled.p`
  font-size: 12px;
  color: ${theme.colors.grey};
  margin-top: 7px;

  &::before {
    content: '※';
  }
`

const FormErrorMessage = styled.p`
  color: ${theme.colors.red};
  font-size: 12px;
  font-weight: bold;
  margin-top: 5px;

  &::before {
    content: 'エラー：';
  }
`
